<template>
  <div class="about">
    <h1>A Site For Events To Better The World</h1>
  </div>
</template>
